<template>
    <div class="md product-class">
        <ul>
            <li
                v-for="item in data"
                :key="item.sn"
                :class="['item-'+ item.sn, item.active? 'is-active': '']"
                :ref="item.sn"
            >
                <router-link
                    class="div"
                    :to="'/system/productList?class='+ item.sn +'&product=all'"
                >
                    <div @click="tagCategory(item)">
                        <div class="image">
                            <div
                                class="mask"
                                :style="'background-image: url('+ item.image +')'"
                            ></div>
                            <img :src="item.image">
                        </div>
                        <div
                            class="essay"
                            @mouseenter="show($event, item)"
                        >
                            <div class="caption">{{ item.caption }}</div>
                            <div class="p">{{ item.content }}</div>
                        </div>
                    </div>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            data: {
                type: Array,
                require: false,
                default: function(){
                    return []
                }
            },
        },
        methods: {
            ...mapMutations([
                'pushToolTip',
            ]),
            show: function(evt, opt){
                
                this.pushToolTip({
                    type: 'toolTip',
                    event: evt,
                    content: {
                        caption: opt.caption,
                        html: opt.content
                    },
                    pointerEvents: 'none'
                })
            },
            UpdateSet: function(){
                let $refs = this.$refs,
                    _pageYOffset = window.pageYOffset,
                    $result = []

                for( let _key in this.$refs ) {
                    let $ref = $refs[_key][0],
                        $rect = $ref.getBoundingClientRect(),
                        _nodeTop = $rect.top;

                    $result.push(_pageYOffset + _nodeTop);
                }

                this.$emit('sendEvent', 'UpdatePos', $result);
            },
            tagCategory: function(obj){
                let date = new Date();
                
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'category',
                    'productType': obj.caption,
                    'currentTime': date.toISOString() //現在時間
                });
            }
        },
        mounted: function(){

            window.setTimeout(() => {
                this.UpdateSet()
            }, 1000);
        }
    }
</script>

<style scoped lang="scss">

    .md.product-class {
        overflow: hidden;
        padding: $interval-l;
        padding-top: 0;
        max-width: $pc-width;
        margin: 0 auto;

        > ul {
            @extend %reset;
            column-count: 3;
            column-gap: $interval-l;

            @include media('mobile') {
                column-count: 2;
            }

            > li {
                position: relative;
                break-inside: avoid;
                padding-bottom: $interval-m;
                opacity: 0;
                transform: translateY(-10vh);
                transition: 1800ms;

                &.is-active {
                    opacity: 1;
                    transform: translateY(0);
                }

                &.item-1 {

                    .image {
                        padding-bottom: 75%;
                    }
                }

                &.item-2 {

                    .image {
                        padding-bottom: 110%;
                    }
                }

                &.item-3 {

                    .image {
                        padding-bottom: 85%;
                    }
                }

                &.item-4 {

                    .image {
                        padding-bottom: 120%;
                    }
                }

                &.item-5 {

                    .image {
                        padding-bottom: 90%;
                    }
                }

                &.item-6 {

                    .image {
                        padding-bottom: 75%;
                    }
                }

                &.item-7 {

                    .image {
                        padding-bottom: 85%;
                    }
                }

                &.item-8 {

                    .image {
                        padding-bottom: 65%;
                    }
                }

                &.item-9 {

                    .image {
                        padding-bottom: 55%;
                    }
                }

                &.item-10 {

                    .image {
                        padding-bottom: 110%;
                    }
                }

                &.item-11 {

                    .image {
                        padding-bottom: 55%;
                    }
                }

                &.item-12 {

                    .image {
                        padding-bottom: 150%;
                    }
                }

                &.item-13 {

                    .image {
                        padding-bottom: 75%;
                    }
                }
            }
        }

        /*a*/.div {
            display: block;
            cursor: pointer;
            transition: $transition;

            &:hover {

                .image {

                    .mask {
                        top: -1 * $interval-m;
                        right: -1 * $interval-m;
                        bottom: -1 * $interval-m;
                        left: -1 * $interval-m;
                    }
                }
            }

            .image {
                position: relative;
                overflow: hidden;
                border-radius: $border-radius;

                @include media('mobile') {
                    padding-bottom: 100% !important;
                }

                .mask {
                    position: absolute;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    transition: $transition;
                }

                img {
                    display: none;
                }
            }

            .essay {
                padding: $interval-m;
                font-weight: bold;
                
                .caption {
                    @extend %ellipsis;
                    font-size: $font-size-xl;
                    color: $forth-color;

                    @include media('mobile') {
                        font-size: $font-size-l;
                    }
                }
                
                .p {
                    @extend %ellipsis;
                    color: $deep;
                }
            }
        }
    }
</style>
